module.exports = __webpack_public_path__ + "6f34c9a643c8340a6cc1b760a72cfff8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/lost-space-ship.png
 ** module id = 541
 ** module chunks = 1
 **/